import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/Benz+Eatery+Phu+Quoc+Vietnam';

const TEXTS = {
  en: {
    badge: 'MUST TRY IN PHU QUOC',
    name: "Benz's Eatery",
    desc: 'Authentic Vietnamese Kitchen · Phu Quoc Island',
    reviews: 'Google reviews',
    menu: 'View Menu',
    directions: 'Get Directions',
  },
  vi: {
    badge: 'PHAI THU O PHU QUOC',
    name: "Benz's Eatery",
    desc: 'Am thuc Viet chinh thong · Dao Phu Quoc',
    reviews: 'danh gia Google',
    menu: 'Xem thuc don',
    directions: 'Chi duong',
  },
};

const LocationPopup = ({ lang = 'en' }) => {
  const [show, setShow] = useState(false);
  const t = TEXTS[lang] || TEXTS.en;

  useEffect(() => {
    const dismissed = sessionStorage.getItem('benz_popup_dismissed');
    if (dismissed) return;
    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('benz_popup_dismissed', '1');
  };

  if (!show) return null;

  return (
    <>
      <div className="blp-popup" data-testid="location-popup">
        <button className="blp-close" onClick={dismiss} data-testid="location-popup-close">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        <div className="blp-badge">{t.badge}</div>
        <div className="blp-row">
          <div className="blp-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#da251d" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          </div>
          <div>
            <h4 className="blp-name">{t.name}</h4>
            <p className="blp-desc">{t.desc}</p>
            <div className="blp-stars">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="#FFB800" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
              <span className="blp-rating">4.8</span>
              <span className="blp-count">1,089 {t.reviews}</span>
            </div>
          </div>
        </div>
        <div className="blp-actions">
          <Link to="/menu" className="blp-btn blp-menu" onClick={dismiss}>{t.menu}</Link>
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="blp-btn blp-dir">{t.directions}</a>
        </div>
      </div>
      <style>{`
        .blp-popup {
          position:fixed; bottom:20px; left:20px; z-index:90;
          background:#fff; border-radius:18px;
          box-shadow:0 16px 48px rgba(0,0,0,0.14),0 0 0 0.5px rgba(0,0,0,0.05);
          padding:18px; width:320px; max-width:calc(100vw - 40px);
          animation:blp-in 0.4s cubic-bezier(0.16,1,0.3,1);
          font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        }
        @keyframes blp-in { from{transform:translateY(80px);opacity:0} to{transform:translateY(0);opacity:1} }
        .blp-close {
          position:absolute;top:10px;right:10px;
          width:26px;height:26px;border-radius:50%;
          background:#f5f3ef;border:none;cursor:pointer;
          display:flex;align-items:center;justify-content:center;color:#6b6660;
        }
        .blp-close:hover{background:#ebe6d9}
        .blp-badge {
          font-size:8.5px;font-weight:800;letter-spacing:0.14em;
          color:#da251d;background:rgba(218,37,29,0.07);
          border-radius:5px;padding:3px 8px;display:inline-block;margin-bottom:10px;
        }
        .blp-row{display:flex;align-items:flex-start;gap:10px;margin-bottom:12px}
        .blp-icon {
          width:36px;height:36px;border-radius:10px;
          background:rgba(218,37,29,0.07);
          display:flex;align-items:center;justify-content:center;flex-shrink:0;
        }
        .blp-name{font-size:15px;font-weight:800;color:#1c1a17;margin:0 0 1px}
        .blp-desc{font-size:11px;color:#9a9590;margin:0 0 3px}
        .blp-stars{display:flex;align-items:center;gap:3px;font-size:11px}
        .blp-rating{font-weight:800;color:#1c1a17}
        .blp-count{color:#9a9590;font-weight:500}
        .blp-actions{display:flex;gap:8px}
        .blp-btn {
          flex:1;padding:9px;border-radius:10px;
          font-size:12px;font-weight:700;text-align:center;
          text-decoration:none;transition:all .15s;
        }
        .blp-menu{background:#da251d;color:#fff}
        .blp-menu:hover{background:#b91c14}
        .blp-dir{background:#f5f3ef;color:#1c1a17}
        .blp-dir:hover{background:#ebe6d9}
        @media(max-width:480px){
          .blp-popup{bottom:12px;left:12px;width:calc(100vw - 24px);padding:14px}
        }
      `}</style>
    </>
  );
};

export default LocationPopup;
